export default __webpack_public_path__ + "static/media/Guide_fill.6d223cef.svg";